.card {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 16px;
  box-shadow: var(--pgm-sys-elevation-level1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  overflow: hidden;
  padding-bottom: var(--pgm-sys-spacing-4);
  position: relative;
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1);
}

.card::before {
  background-color: var(--pgm-sys-color-on-surface-variant);
  content: "";
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 150ms cubic-bezier(0.2, 0, 0, 1);
  z-index: 1;
}

.card:hover::before {
  opacity: 0.08;
}

.card:active::before {
  opacity: 0.1;
}

.card:hover {
  box-shadow: var(--pgm-sys-elevation-level2);
}

.image {
  background-color: var(--pgm-sys-color-surface-container-high);
  border-radius: 16px 16px 8px 8px;
  display: block;
  height: 216px;
  object-fit: cover;
  width: 100%;
}

.small .image {
  height: 76px;
}

.infos {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: 0 var(--pgm-sys-spacing-4);
}

.date {
  color: var(--pgm-sys-color-primary);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.card .link {
  color: inherit;
  text-decoration: none;
}

.card .link::after {
  content: "";
  inset: 0;
  position: absolute;
  z-index: 2;
}

.card .link:hover,
.card .link:focus {
  color: inherit;
  text-decoration: none;
}

.card .link:focus-visible::after {
  border-radius: 16px;
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

@media (prefers-reduced-motion: reduce) {
  .card,
  .card::before {
    transition: none;
  }
}
